/*
    自定义日期选择器组件
    2020-8-11
    zs
*/

<template>
  <div>
    <el-popover
    placement="top"
    width="600"
    class="datePicker"
    trigger="click"
    ref="popover"
    @show="openDate"
    >
      <div class="bodyinfo" style="position:relative" v-loading="tabloading">
        <div>
            <div :class="{'yearMonths':true,'yearMonths-right':!$store.state.lang}">
                <div class="yearMonths-box">
                    <el-date-picker v-model="selectmonth" type="month" :placeholder="$t('Dailyequipment.placehoder2')" :picker-options="pickerOptions" @change="getDate(0)"></el-date-picker>
                </div>
            </div>
            <div class="nextMonth" v-show="nextMonthNone && $store.state.lang">下个月</div>
            <div class="nextMonth" v-show="nextMonthNone && !$store.state.lang">Next Month</div>
        </div>
        <el-calendar v-model="selectmonth" :first-day-of-week='0' class="sc001calendar calendar1" >
            <template
                slot="dateCell"
                slot-scope="{data}"
                >
                <div style="width: 100%;height: 100%;" @click="timeClick(data.day,filename[data.day])" v-show="data.day<=nowDate">
                    <p :class="data.isSelected ? 'is-selected' : ''" v-show="data.day.split('-').join('-').substring(0,7)===currentMonth">
                        {{ data.day.split('-').slice(2).join('-') }}
                    </p>
                     <div  class="downloadbox" style="width: 100%;height: 100%;" v-show="filename[data.day]==''&&data.day.split('-').join('-').substring(0,7)===currentMonth">
                        <p>{{$t('Dailyequipment.placehoder4')}}</p>
                    </div>
                </div>
            </template>
        </el-calendar>
      </div>
      <el-input class="selectDate" slot="reference" placeholder="请选择日期" :readonly='true' prefix-icon="el-icon-date" v-model="showVal"></el-input>
    </el-popover>
  </div>
</template>

<script>
let timer = new Date();
export default {
  name: 'CustomDatePicker',
  props:['index','machineId','time'],
  computed:{
    istime(){
      return this.time
    }
  },
  watch:{
    selectmonth(){
      this.noNextMonth()//控制月份不能大于当前月份
          //下个月禁用状态
      if(this.selectmonth === null){
        this.nextMonthNone = true
        return
      }
      let year = new Date().getFullYear()//此刻的年份
      let mon = new Date().getMonth()+1//此刻的月份
      let nonyear = this.selectmonth.getFullYear()//选择的年份
      let nowMon = this.selectmonth.getMonth()+1//选择的月份
      if(nowMon<10){
        nowMon = '0'+nowMon
      }
      this.currentMonth=nonyear+'-'+nowMon
      if(nowMon >= mon && nonyear>= year){
          this.nextMonthNone = true
      }else{
          this.nextMonthNone = false
      }
    },
    machineId(){
      this.selectmonth=new Date()
    },
    time(){
      this.showVal=this.time
    },
  },
  data() {
    return {
        showVal: '',
        tabloading:false,
        pickerOptions: {
          disabledDate(time) {
              return time.getTime() > Date.now();
          }
        },
        // 选择的月份
        selectmonth:new Date(),
        nextMonthNone:true,
        currentMonth:'',
        filename:[],
        nowDate:''
    }
  },
  created () {
    
      if(this.time){
        this.showVal=this.time
      }
      let year = new Date().getFullYear()//此刻的年份
      let mon = new Date().getMonth()+1//此刻的月份
      let day = new Date().getDate()//此刻的日
      if(mon <10){
        mon = "0"+mon
      }
      if(day<10){
        day = "0"+ day
      }
      this.nowDate=year+'-'+mon+'-'+day

      let nowY = this.selectmonth.getFullYear()
      let nowM = this.selectmonth.getMonth() + 1
      if(nowM<10){
        nowM = '0'+nowM
      }
      this.currentMonth=nowY+'-'+nowM
      this.$nextTick(() => {
        // 点击前一个月
        let prevBtn = document.querySelector(
          ".calendar1 .el-calendar__button-group .el-button-group>button:nth-child(1)"
        );
        prevBtn.addEventListener("click", () => {
          this.getDate(Number(this.index)+1)
        });
        //点击下一个月
        let nextBtn = document.querySelector(
          ".calendar1 .el-calendar__button-group .el-button-group>button:nth-child(3)"
        );
        nextBtn.addEventListener("click", () => {
          this.getDate(Number(this.index)+1)
        })
        
        //点击今天
        let todayBtn = document.querySelector(
          ".calendar1 .el-calendar__button-group .el-button-group>button:nth-child(2)"
        );
        todayBtn.addEventListener("click", () => {
          this.getDate(Number(this.index)+1)
        });
      });
    
  },
  mounted () {
    
  },
  destroyed () {
    
  },
  methods: {
    openDate(){
      this.getDate(Number(this.index)+1)
    },
    getDate(){
      let _this = this
      _this.tabloading=true
      _this.filename=[]
      let nonyear = this.selectmonth.getFullYear()//选择的年份
      let nowMon = this.selectmonth.getMonth()+1//选择的月份
      if(nowMon<10){
        nowMon= "0"+ nowMon
      }
      let nowdate = nonyear+'-'+nowMon+'-01'
      _this.axios({
        method: 'get',
        url: '/url/dailyEquipmentParameters',
        params:{
          type:Number(this.index)+1,
          machineId:this.machineId,
          language: _this.$store.state.lang,
          time:nowdate,
        }
      }).then(function(res){
        if(res.data.success==='true'){
          _this.filename=res.data.list
        }else{
          _this.$message.error(res.data.msg);
        }
        _this.tabloading=false
      })
    },
    noNextMonth(){
      if(this.selectmonth > new Date()){
        this.selectmonth = timer
      }
    },
    // 点击时间
    timeClick(t,name){
      this.showVal=t
      this.$refs.popover.doClose()
      this.$emit('change',t,name)
    }
  } 
}
</script>

<style scoped>
.selectDate{
  width: 150px;
}
.yearMonths{
    width: 118px;
    position: absolute;
    right: 230px;
    top: 11px;
    height: 28px;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    overflow: hidden;
}
.yearMonths .yearMonths-box{
    position: absolute;
    top: -6px;
    left:-1px;
}
.downloadbox{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.nextMonth{
   
    position: absolute;
    top: 12px;
    right: 20px;
    z-index: 10;
    border:1px solid #DCDFE6;
    border-left: none;
    color: #C0C4CC;
    font-size: 12px;
    line-height: 12px;
    padding: 7px 15px;
    text-align: center;
    border-radius: 0 3px 3px 0;
    background-color: #F5F7FA;
    cursor:no-drop;/* 鼠标悬浮禁用 */
    user-select: none;
    font-family: "Arial";
}
.yearMonths-right{
  right: 310px;
}
.current .el-calendar-day .downloadbox{
    color:#adafb2;
    font-size:16px;
}
.prev .el-calendar-day .downloadbox{
    color:#B2D2F5;
    font-size:16px;
}
.next .el-calendar-day .downloadbox{
    color:#B2D2F5;
    font-size:16px;
}
.el-calendar-table td.is-selected{
    background:#fff!important;
    color:#3782E4!important;
    float:right;
} 
</style>
